import global$1 from './global.js';
import toAbsoluteIndex$1 from './to-absolute-index.js';
import lengthOfArrayLike$1 from './length-of-array-like.js';
import createProperty$1 from './create-property.js';

var global = global$1;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;
var createProperty = createProperty$1;
var Array = global.Array;
var max = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array(max(fin - k, 0));

  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);

  result.length = n;
  return result;
};

export { arraySliceSimple as default };
